<template>
    <div :id="modalId" uk-modal class="employee-certification-form">
        <div class="uk-modal-dialog uk-modal-body">
            <h2 class="uk-modal-title uk-margin-medium-bottom">Certification</h2>
            <div class="uk-grid">
                <div class="uk-form-controls uk-width-2-3">
                    <div class="uk-form-label">Certification</div>
                    {{ certificationName }}
                </div>
                <div class="uk-form-controls uk-width-1-3">
                    <div class="uk-form-label">Completion Date</div>
                    {{ formatDate(certified) }}
                </div>
            </div>
            <div class="uk-form-label">Documents</div>
            <div v-for="doc in documents">
                <a :href="doc.url" target="_blank" >{{ doc.name }}</a>
            </div>
            <div class="uk-margin-medium-bottom"></div>
            <button class="uk-button uk-button-tertiary uk-modal-close" type="button" @click="cancel()">Done</button>
        </div>
    </div>
</template>

<script>
    import Moment from "moment";
    export default {
        name: "EmployeeCertificationView",

        props:{
            uid:Number,
            modalId:String,
            tableRef:String
        },

        data(){
            return {
                personCertificationId:null,
                certificationOptions:[],
                certificationId:0,
                certificationName:"",
                certified:"",
                certifiedDateString:"",
                documents:[]
            }
        },

        mounted(){

        },
        methods:{
            loadForm(id){
                this.personCertificationId = id;
                axios.get("/api/employee/"+this.uid+"/certification/" + id)
                    .then((pack) => this.formLoaded(pack));
            },
            formLoaded(pack){
                let dt = pack.data.data;
                this.certificationId = dt.certification_id;
                this.certificationName = dt.certification.name;
                this.certified = dt.certified;
                this.documents = dt.documents;
            },
            updateCertificationData(pack){
                let dt = pack.data.data;
                this.certificationOptions = dt;
            },
            dataUpdated(pack){
                this.$root.$refs[this.tableRef].loadCertifications();
            },
            cancel(){
                if(this.personCertificationId){
                    this.personCertificationId = null;
                    this.certificationId = 0;
                    this.certified = "";
                }

            },
            formatDate(dateString){
                let date = new Moment(dateString);
                return date.format("MM/DD/YYYY");
            },
            completionDateSet(val){
                this.certifiedDateString = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
            }
        }
    }
</script>

<style scoped>

</style>
